// Ensure dataLayer exists
window.dataLayer = window.dataLayer || [];

/**
 * Fire additional events when ready
 */
document.addEventListener('DOMContentLoaded', () => {
	if (!window.pageData) {
		return;
	}

	// Push pageTerm events for each term
	window.pageData?.postTerms?.forEach(postTerm => {
		window.dataLayer.push({
			event: 'pageTerm',
			pageTerm: postTerm
		});
	});

});

